/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { EnforcementStateEnum } from './enforcementStateEnum';
import { EnforcementSignalStatusEnum } from './enforcementSignalStatusEnum';


export interface EnforcementSignalRecord { 
    id?: number;
    org_id?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    enforcement_type?: string;
    signal_data?: string;
    state?: EnforcementStateEnum;
    status?: EnforcementSignalStatusEnum;
    state_entered_ts?: Date;
    next_action_ts?: Date;
    created_ts?: Date;
    updated_ts?: Date;
}
export namespace EnforcementSignalRecord {
}


